import { render, staticRenderFns } from "./AssessorXRef.vue?vue&type=template&id=1bc6310e&"
import script from "./AssessorXRef.vue?vue&type=script&lang=js&"
export * from "./AssessorXRef.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports